

function show_proven(nom) {
  $(".slider_proven .item").removeClass('slick-current');
  $("div[data-slick-index='" + nom +"']").addClass('slick-current'); 
  $(".slider_proven_text").removeClass('active');
  $('#slider_proven_text_'+nom).addClass('active');
}

$('.slider_fancy_block').click(function(){
    var ids=$(this).attr("id");
  	$.fancybox.open([
	{
		src  : '#show_'+ids/*,
      	opts : {
          beforeShow : function() {
              $('iframe:first').attr('src', $('iframe:first').attr('src')+'&autoplay=1');
          },
          beforeClose : function () {          	
            $('iframe:first').attr('src', 'https://player.vimeo.com/video/415982245?title=0&byline=0&amp;portrait=0&amp;controls=0');
            vimeoWrap = $('iframe:first');
            vimeoWrap.html(vimeoWrap.html());
          }
		}*/
      }
	]);
    
  })
  
  
if ($('.slider_ingredients_2').length) { 
 
    $('.slider_ingredients_2').not(".slick-initialized").slick({
	  slidesToShow: 2,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: true,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			 
			 
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 1
			}
			} 
			]
	});
    
  
}
  



  
if ($('.slider_ingredients').length) { 
 
    $('.slider_ingredients').not(".slick-initialized").slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: true,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			 
			{
			breakpoint: 1200,
			settings: {
			slidesToShow: 4 
			}
			},
			{
			breakpoint: 991,
			settings: {
			slidesToShow: 3 
			}
			},
			{
			breakpoint: 768,
			settings: {
			slidesToShow: 2 
			}
			} ,
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 1
			}
			} 
			]
	});
    
  
}


if ($('.slider_ingredients_white').length) { 
 
    $('.slider_ingredients_white').not(".slick-initialized").slick({
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: true,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			 
			 
			{
			breakpoint: 768,
			settings: {
			slidesToShow: 2 
			}
			} ,
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 1
			}
			} 
			]
	});
    
  
}


if ($('.related_slider').length) { 
 
    $('.related_slider').not(".slick-initialized").slick({
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: false,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			
			{
			breakpoint: 991,
			settings: {
			slidesToShow: 2 
			}
			} ,
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 1
			}
			} 
			]
	});
    
  
} 



if ($('.home-logo-lists-carousel').length) { 
 
    $('.home-logo-lists-carousel').not(".slick-initialized").slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: false,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			 
			{
			breakpoint: 1200,
			settings: {
			slidesToShow: 4 
			}
			},
			{
			breakpoint: 991,
			settings: {
			slidesToShow: 3 
			}
			},
			{
			breakpoint: 768,
			settings: {
			slidesToShow: 2 
			}
			} ,
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 1
			}
			} 
			]
	});
    
  
} 


if ($('.slider_customers').length) { 
 
    $('.slider_customers').not(".slick-initialized").slick({
	  slidesToShow: 4,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: true,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			 
			{
			breakpoint: 1200,
			settings: {
			slidesToShow: 3 
			}
			},
			{
			breakpoint: 991,
			settings: {
			slidesToShow: 2 
			}
			},
			{
			breakpoint: 768,
			settings: {
			slidesToShow: 2 
			}
			} ,
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 1
			}
			} 
			]
	});
    
  
} 


if ($('.slider_proven').length) { 
 
    $('.slider_proven').not(".slick-initialized").slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  infinite: false,
	  dots: false,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			 
			 
			{
			breakpoint: 991,
			settings: {
			slidesToShow: 3 
			}
			},
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 2 
			}
			} 
			]
	});
    
  $(".slider_proven").on("beforeChange", function (event, slick, currentSlide, nextSlide){
   
    nom=nextSlide;
      $(".slider_proven .item").removeClass('slick-current');
  $("div[data-slick-index='" + nom +"']").addClass('slick-current'); 
  $(".slider_proven_text").removeClass('active');
  $('#slider_proven_text_'+nom).addClass('active');
});
}


if ($('.row_questions').length) { 
  $('.row_questions .title').click(function(){
  	var ids=$(this).attr('id');
    
    if ( $('#show_'+ids).hasClass('active')) {
      $('#show_'+ids).removeClass('active'); 
      	$('#show_'+ids+' .descr').slideUp();
      
    } else {
     	$('#show_'+ids).addClass('active'); 
      	$('#show_'+ids+' .descr').slideDown();
      
    }
    
  })
  
}


  $('.show_qty_discounts').click(function(){
  	$.fancybox.open([
	{
		src  : '#id_show_qty_discounts'
	}
]);
    
  })


if ($('.home-video__items').length) { 
 
    $('.home-video__items').not(".slick-initialized").slick({
	  slidesToShow: 6,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: false,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			 
			{
			breakpoint: 1200,
			settings: {
			slidesToShow: 5 
			}
			},
			{
			breakpoint: 991,
			settings: {
			slidesToShow: 4 
			}
			},
			{
			breakpoint: 768,
			settings: {
			slidesToShow: 3 
			}
			} ,
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 2
			}
			} 
			]
	});
    
  
} 


$('.goto_scroll').on( 'click', function(){ 
    var el = $(this);
    var dest = el.attr('href');  
    if(dest !== undefined && dest !== '') { 
        $('html').animate({ 
            scrollTop: $(dest).offset().top 
        }, 2000 
        );
    }
    return false;
});

 


if ($('.iframe_other').length) {
  //$( ".iframe_other" ).each(function( index ) {
   // $(this).contents().find("head").append($("<style type='text/css'> body{padding:0;margin:0;}  </style>"));  
//}); 
}

if ($('.slider_solutions').length) { 
 
    $('.slider_solutions').not(".slick-initialized").slick({
	  slidesToShow: 7,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: true,arrows: true,
	  prevArrow:
		'<div class="prev"><i class="icon icon--left-l"></i></div>',
	  nextArrow:
		'<div class="next"><i class="icon icon--right-l"></i></div>',
	  responsive: [
			 
			{
			breakpoint: 1200,
			settings: {
			slidesToShow: 4 
			}
			},
			{
			breakpoint: 991,
			settings: {
			slidesToShow: 4 
			}
			},
			{
			breakpoint: 768,
			settings: {
			slidesToShow: 3 
			}
			} ,
			{
			breakpoint: 576,
			settings: {
			slidesToShow: 2
			}
			} 
			]
	});
    
  
} 
                
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}
 

$( ".product-single__accordion__title" ).click(function( event ) {
  event.preventDefault();
  
}); 